enum TypeDevice {
  Web = 'web',
  SensorPanel = 'kiosk'
}

export default TypeDevice
